import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionDeniedService {
  private _show = new BehaviorSubject<boolean>(false);
  private _permission = new BehaviorSubject<string>('');
  private timer: any;

  public show$ = this._show.asObservable();
  public permission$ = this._permission.asObservable();

  constructor() { }

  show(permission: string) {
    this._permission.next(permission);
    this._show.next(true);

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.hide();
    }, 10000);
  }

  hide() {
    this._show.next(false);
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
